module.exports = __webpack_public_path__ + "img/17_107.1bfd3bd4.png";